import React, { useState } from 'react'
import {
  Card,
  Button,
  Collapse,
  Row,
  Checkbox,
  Col,
  Modal,
  Form,
  message,
  Spin
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { loadData } from '../../../appRedux/actions/Setting'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  ADD_ONS,
  GIFT_CARDS,
  GIFT_CARD_REPORT,
  MAIN_SALE_SCREEN,
  PERSONAL_TOKENS,
  REPORTS_DASHBOARD,
  SALES_LEDGER,
  SALE_HISTORY,
  STATUS,
  USERROLES_SCREEN,
  SALE_TRACKING_SCREEN,
  HOME
} from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const Panel = Collapse.Panel
const confirm = Modal.confirm
const uri = 'https://mozilla.org/?x=шеллы'
const encoded = encodeURI(uri)

const AddEditRolesRights = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [getIsLoading, setIsLoading] = React.useState(true)
  const [getOutletsDeSelect, setOutletsDeSelect] = useState([])
  const [imageUrl, setimageUrl] = useState(false)
  const [getOutletsData, setOutletsData] = useState([])
  const [getRolesData, setRolesData] = useState([])
  const [getAllMenus, setAllMenus] = useState([])
  const [getRoleName, setRoleName] = useState('')
  const [getRoleId, setRoleId] = useState('')
  const [getShowDelete, setShowDelete] = useState('')
  const [getCurrSymbol, setCurrSymbol] = React.useState('')
  const [getIsAllowRead, setIsAllowRead] = React.useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = React.useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = React.useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = React.useState(true)
  const [getAccessLoading, setAccessLoading] = React.useState(true)
  const [getRights, setRights] = React.useState([])
  const [getPermissions, setPermissions] = React.useState([])
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  React.useEffect(() => {
    // ;
    dispatch(setCommonConfigs(USERROLES_SCREEN))
    let roleId = ''
    // console.log(encoded);
    if (window.location.href.includes('/new/')) {
      // let encodedUri = encodeURI();
      let decodedUri = decodeURI(window.location.href)
      let url = decodedUri.split('new/')
      let roleName = url.length > 1 ? url[1] : ''
      // console.log("olala", roleName);
      setRoleName(roleName)
    } else {
      const decodeddUri = decodeURI(window.location.href)
      let url = window.location.href.split('addeditroles/')
      roleId = url.length > 1 ? url[1] : ''
      setRoleId(roleId)

      let nameURL = decodeddUri.split('addeditroles/')
      nameURL = nameURL.length > 1 ? nameURL[1] : ''
      nameURL = nameURL.includes('/') ? nameURL.split('/') : []
      let roleeName = nameURL.length > 1 ? nameURL[1] : 'Selected Role'
      let isShowDelete = nameURL.length > 2 ? nameURL[2] : ''
      setRoleName(roleeName)
      setShowDelete(isShowDelete.toString())
    }
    if (roleId != '') {
      if (!verifyPkgFeature(PkgFeatures.CustomUserRoles)) {
        setIsFeatureAllowed(false)
      }
      let body = {
        sRoleId: roleId
      }
      getRolesRightsDataService(body)
    } else {
      getMenusService()
    }

    // let menus = localStorage.getItem("menu");
    // menus = JSON.parse(menus);
    // let menuData = menus.menus.map((e) => {
    //   return {
    //     displaySeqNo: e.displaySeqNo,
    //     displayText: e.displayText,
    //     iconClassName: e.iconClassName,
    //     menuNavigationID: e.menuNavigationID,
    //     menuURL: e.menuURL,
    //     parentMenuName: e.parentMenuName,
    //     parentMenuNavigationID: e.parentMenuNavigationID,
    //     isSelect: false,
    //   };
    // });
    // setAllMenus(menuData);
  }, [])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
      }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  async function getRolesRightsDataService (id) {
    // ;
    const getRolesData = ds.getRoleRightsByID(id, BEHAVIOUR_TYPE.GET)
    await getRolesData
      .then(response => {
        setIsLoading(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data) {
              let data = response.data.data
              setAllMenus(data)
            } else {
              setIsLoading(false)
              message.error('Something Went Wrong...')
            }
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function getMenusService () {
    // ;
    const getMenus = ds.getMenusRights('', BEHAVIOUR_TYPE.GET)
    await getMenus
      .then(response => {
        setIsLoading(false)
        if (response.status == 200) {
          if (response.data.data) {
            let data = response.data.data
            setAllMenus(data)
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function postRolesService (body, methodType, featureID) {
    const postRoles = ds.postRoles(body, methodType, featureID)
    await postRoles
      .then(response => {
        // setIsLoading(false);
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data == true) {
              message.success('Saved Successfully')
            } else {
              message.error('Something went wrong')
            }
            dispatch(loadData(true))
            setTimeout(() => {
              setIsLoading(false)
              history.push('/dashboard/setup/users/listing')
            }, 2000)
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }

  const onFinish = values => {
    setIsLoading(true)
    getAllMenus &&
      getAllMenus.length &&
      getAllMenus
        .filter(a => a.isSelect == true)
        .map(x => {
          x.pageRight = [
            {
              isSelect: true,
              rightId: 2,
              rightName: 'Read'
            }
          ]
        })
    const methType =
      getRoleId == '' ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE
    let behavior = getRoleId == '' ? 1 : 3
    let body = {
      roleId: getRoleId,
      roleName: getRoleName,
      behaviorName: behavior,
      ritesAndPermission: getAllMenus
    }
    postRolesService(
      body,
      methType,
      getRoleId == '' ? PkgFeatures.RetailPOS : PkgFeatures.CustomUserRoles
    )
    // let permExist =
    //   getAllMenus &&
    //   getAllMenus.length &&
    //   getAllMenus.filter((a) => a.isSelect == true);
    // if (permExist && permExist.length && permExist.length > 0) {
    //   //this is because parent menu is 1st child menu, should be done on pageID from backend and frontend

    //   // let supposedArr = [...getAllMenus];
    //   // for (let i = 0; i < supposedArr.length; i++) {
    //   //   if (supposedArr[i] && supposedArr[i].childMenu && supposedArr[i].childMenu.length && supposedArr[i].childMenu.length > 0) {
    //   //     let parentMenuPageID = supposedArr[i].pageId;
    //   //     let childMenu = supposedArr[i].childMenu.filter(a=>a.PageId == parentMenuPageID);
    //   //   }
    //   // }
    //   let parentMenuName;

    //   //this is because parent menu is 1st child menu, should be done on pageID from backend and frontend

    //   setIsLoading(true);
    //   const methType = getRoleId == "" ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE;
    //   let behavior = getRoleId == "" ? 1 : 3;
    //   let body = {
    //     roleId: getRoleId,
    //     roleName: getRoleName,
    //     behaviorName: behavior,
    //     ritesAndPermission: getAllMenus,
    //   };
    //   postRolesService(body, methType);
    // } else {
    //   message.error("Kindly give some access to this Role");
    // }
  }

  const onFinishFailed = errorInfo => {
    //;
    message.error('Kindly Attend To Missing Field')
  }

  function handleCancel () {
    message.success('cancel')
  }

  function onMainMenuSelect (ee, isChild) {
    let data = [...getAllMenus]
    if (data && data.length) {
      if (!isChild) {
        let index = data.findIndex(a => a.pageId == ee)
        // let index = data.findIndex((a) => a.menuNavigationID == ee);
        data[index].isSelect = !data[index].isSelect
        if (data[index].childMenu.length) {
          let childIndex = data[index].childMenu.findIndex(a => a.pageId == ee)
          if (childIndex !== -1) {
            data[index].childMenu[childIndex].isSelect = data[index].isSelect
          }
        }
        setAllMenus(data)
      } else {
        let parentIndex = data.findIndex(a => a.pageId == isChild)
        let index = data[parentIndex].childMenu.findIndex(a => a.pageId == ee)
        data[parentIndex].childMenu[index].isSelect =
          !data[parentIndex].childMenu[index].isSelect

        // // NOTE: When the parent is true then by default all children became true
        if (data[parentIndex].childMenu[index].isSelect) {
          if (
            data[parentIndex].childMenu[index].childPagePermissionRights &&
            data[parentIndex].childMenu[index].childPagePermissionRights
              .length > 0
          ) {
            data[parentIndex].childMenu[index].childPagePermissionRights.map(
              qw => {
                qw.isSelect = true
              }
            )
          }
          if (
            data[parentIndex].childMenu[index].childRights &&
            data[parentIndex].childMenu[index].childRights.length > 0
          ) {
            data[parentIndex].childMenu[index].childRights.map(qw => {
              qw.isSelect = true
            })
          }
        }
        setAllMenus(data)
      }
    }

    // // 1. Make a shallow copy of the items
    // let items = [...getAllMenus];
  }

  function onRightSelect (parentPageId, childPageId, rightId, rightName) {
    let data = [...getAllMenus]
    if (data && data.length) {
      let parentIndex = data.findIndex(a => a.pageId == parentPageId)
      let childIndex = data[parentIndex].childMenu.findIndex(
        a => a.pageId == childPageId
      )
      // if click on read then all other rights will automatically be denied
      if (rightName == READ) {
        let isReadTrue = data[parentIndex].childMenu[
          childIndex
        ].childRights.filter(a => a.rightName == READ)
        isReadTrue = isReadTrue.length > 0 ? isReadTrue[0].isSelect : false
        if (isReadTrue) {
          // all rights denied
          if (
            data[parentIndex].childMenu[childIndex].childRights &&
            data[parentIndex].childMenu[childIndex].childRights.length > 0
          ) {
            data[parentIndex].childMenu[childIndex].childRights.map(w => {
              w.isSelect = false
            })
          }
          // all permission denied
          if (
            data[parentIndex].childMenu[childIndex].childPagePermissionRights &&
            data[parentIndex].childMenu[childIndex].childPagePermissionRights
              .length > 0
          ) {
            data[parentIndex].childMenu[
              childIndex
            ].childPagePermissionRights.map(w => {
              w.isSelect = false
            })
          }
        } else {
          let readIndex = data[parentIndex].childMenu[
            childIndex
          ].childRights.findIndex(a => a.rightName == READ)
          data[parentIndex].childMenu[childIndex].childRights[
            readIndex
          ].isSelect = true
        }
      } else {
        let rightIndex = data[parentIndex].childMenu[
          childIndex
        ].childRights.findIndex(a => a.rightId == rightId)
        data[parentIndex].childMenu[childIndex].childRights[
          rightIndex
        ].isSelect =
          !data[parentIndex].childMenu[childIndex].childRights[rightIndex]
            .isSelect
      }
      setAllMenus(data)
    }
  }

  function onPermissionSelect (parentPageId, childPageId, permId) {
    // ;
    let data = [...getAllMenus]
    if (data && data.length) {
      let parentIndex = data.findIndex(a => a.pageId == parentPageId)
      let childIndex = data[parentIndex].childMenu.findIndex(
        a => a.pageId == childPageId
      )
      let permIndex = data[parentIndex].childMenu[
        childIndex
      ].childPagePermissionRights.findIndex(
        a => a.pagePermissionTypeID == permId
      )
      data[parentIndex].childMenu[childIndex].childPagePermissionRights[
        permIndex
      ].isSelect =
        !data[parentIndex].childMenu[childIndex].childPagePermissionRights[
          permIndex
        ].isSelect
      setAllMenus(data)
    }

    // // 1. Make a shallow copy of the items
    // let items = [...getAllMenus];
  }

  function onParentRightSelect (parentPageId, rightId) {
    let data = [...getAllMenus]
    if (data && data.length) {
      let index = data.findIndex(a => a.pageId == parentPageId)
      let rightIndex = data[index].pageRight.findIndex(
        a => a.rightId == rightId
      )
      data[index].pageRight[rightIndex].isSelect =
        !data[index].pageRight[rightIndex].isSelect
      setAllMenus(data)
    }
  }

  function onParentPermSelect (parentPageId, permId) {
    let data = [...getAllMenus]
    if (data && data.length) {
      let index = data.findIndex(a => a.pageId == parentPageId)
      let permIndex = data[index].pagePermission.findIndex(
        a => a.pagePermissionTypeID == permId
      )
      data[index].pagePermission[permIndex].isSelect =
        !data[index].pagePermission[permIndex].isSelect
      setAllMenus(data)
    }
  }

  function onDeleteBtn () {
    if (getRoleId != '') {
      let body = {
        roleId: getRoleId,
        behaviorName: 2
      }
      setIsLoading(true)
      postRolesService(body, BEHAVIOUR_TYPE.DELETE)
    } else {
      message.warn('Kindly first select a role to delete')
    }
  }

  function showDeleteConfirm () {
    confirm({
      title: "Are you sure you want to delete this 'ROLE'?",
      content:
        "By doing so you are going to delete this 'ROLE' from the system!",
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        onDeleteBtn()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <>
      <div className='Content-wrapper Rights&Permissions-pg'>
        <div className='back-arrow-h1'>
          <h1 className='d-flex align-items-center'>
            <ArrowLeftOutlined
              onClick={() => {
                history.push('/dashboard/setup/users/listing')
              }}
            />
            <span className='mx-2'>
              <IntlMessages id='setup.userroles.head' />
              {` ${getRoleName}`}
            </span>
          </h1>
        </div>

        <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
          <Col lg={18} md={16} sm={14} xs={24}>
            <p className='title vd-hero-intro custom-font-color-black m-0'>
              <IntlMessages id='setup.userroles.head2' />
            </p>
          </Col>

          <Col lg={6} md={8} sm={10} xs={24}>
            <div className='pg-header-btn'>
              {getRoleId && (
                <Button
                  onClick={() => showDeleteConfirm()}
                  className='dk-btn-cancel'
                  type='primary'
                  size='large'
                  // disabled={getShowDelete == "0" ? true : false}
                  disabled={getIsDisableDelete}
                >
                  <IntlMessages id='setup.userroles.delete' />
                </Button>
              )}

              <Form
                form={form}
                name='roleRightForm'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
              >
                <Form.Item>
                  <Button
                    className='dk-btn-add'
                    htmlType='submit'
                    type='primary'
                    size='large'
                    disabled={
                      getRoleId == '' ? getIsDisableCreate : getIsDisableUpdate
                    }
                  >
                    <IntlMessages id='setup.userroles.save' />
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>

        <Row className='mt-4'>
          <Col span={24}>
            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mb-0'>
              <IntlMessages id='setup.userroles.menus' />
            </h2>

            <Spin
              tip={<IntlMessages id='setup.userroles.loader' />}
              spinning={getIsLoading}
              size='large'
              style={{ display: 'block' }}
            >
              <Card
                className='gx-card no-shadow-pad mark-header'
                title={<IntlMessages id='setup.userroles.access' />}
              >
                {getAllMenus &&
                  getAllMenus.length &&
                  getAllMenus
                    .filter(q => q.pageId != SALES_LEDGER)
                    .map((e, key) => {
                      return (
                        <Collapse key={key} style={{ cursor: 'pointer' }}>
                          <Panel
                            className='letmedown'
                            showArrow={false}
                            header={e.displayText}
                          >
                            <Card className='gx-card no-shadow-pad'>
                              <p>
                                <Checkbox
                                  checked={e.isSelect}
                                  onChange={() =>
                                    onMainMenuSelect(e.pageId, false)
                                  }
                                >
                                  {e.displayText}
                                </Checkbox>
                              </p>
                              <p>
                                {!e.isSelect && (
                                  <Button
                                    type='primary'
                                    size='small'
                                    onClick={() =>
                                      onMainMenuSelect(e.pageId, false)
                                    }
                                  >
                                    {
                                      <IntlMessages id='setup.userroles.allow' />
                                    }
                                  </Button>
                                )}
                              </p>

                              <div className='gx-module-box-content'>
                                {e.isSelect && e.childMenu.length > 0 ? (
                                  <>
                                    {e.childMenu
                                      .filter(
                                        p =>
                                          p.pageId != STATUS &&
                                          p.pageId != GIFT_CARD_REPORT &&
                                          p.pageId != ADD_ONS &&
                                          p.pageId != PERSONAL_TOKENS &&
                                          p.pageId != GIFT_CARDS
                                      )
                                      .map((f, key) => {
                                        return (
                                          <div
                                            key={key}
                                            className='gx-module-list-item'
                                          >
                                            <div className='gx-module-list-icon'>
                                              <Checkbox
                                                color='primary'
                                                checked={f.isSelect}
                                                onClick={event => {
                                                  onMainMenuSelect(
                                                    f.pageId,
                                                    e.pageId
                                                  )
                                                }}
                                                // value="SelectTodo"
                                                className='gx-icon-btn'
                                              />
                                            </div>
                                            <div
                                              className='gx-module-list-info'
                                              onClick={() => {
                                                onMainMenuSelect(
                                                  f.pageId,
                                                  e.pageId
                                                )
                                              }}
                                            >
                                              <div className='gx-module-todo-content'>
                                                <div
                                                  className={`gx-subject ${
                                                    false &&
                                                    'gx-text-muted gx-text-strikethrough'
                                                  }`}
                                                >
                                                  {f.displayText}
                                                </div>
                                              </div>
                                            </div>

                                            <div className='gx-module-box-content'>
                                              {f.pageId == MAIN_SALE_SCREEN ? (
                                                <>
                                                  {f.isSelect &&
                                                    f.childRights &&
                                                    f.childRights.length > 0 &&
                                                    f.childRights
                                                      .filter(
                                                        df =>
                                                          df.rightName !=
                                                            READ &&
                                                          df.rightName !=
                                                            UPDATE &&
                                                          df.rightName != DELETE
                                                      )
                                                      .map((g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onRightSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.rightId,
                                                                    g.rightName
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onRightSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.rightId,
                                                                  g.rightName
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {g.rightName ==
                                                                  CREATE
                                                                    ? 'Make Sales'
                                                                    : g.rightName}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      })}

                                                  {f.isSelect &&
                                                  f.childPagePermissionRights &&
                                                  f.childPagePermissionRights
                                                    .length ? (
                                                    f.childPagePermissionRights.map(
                                                      (g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onPermissionSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.pagePermissionTypeID
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onPermissionSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.pagePermissionTypeID
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {
                                                                    g.permissionTypeName
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    )
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              ) : f.pageId == SALE_HISTORY ? (
                                                <>
                                                  {f.isSelect &&
                                                    f.childRights &&
                                                    f.childRights.length > 0 &&
                                                    f.childRights
                                                      .filter(
                                                        df =>
                                                          df.rightName !=
                                                            CREATE &&
                                                          df.rightName !=
                                                            UPDATE &&
                                                          df.rightName != DELETE
                                                      )
                                                      .map((g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onRightSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.rightId,
                                                                    g.rightName
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onRightSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.rightId,
                                                                  g.rightName
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {g.rightName}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      })}

                                                  {f.isSelect &&
                                                  f.childPagePermissionRights &&
                                                  f.childPagePermissionRights
                                                    .length ? (
                                                    f.childPagePermissionRights.map(
                                                      (g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onPermissionSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.pagePermissionTypeID
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onPermissionSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.pagePermissionTypeID
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {
                                                                    g.permissionTypeName
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    )
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              ) : f.pageId ==
                                                SALE_TRACKING_SCREEN ? (
                                                <>
                                                  {f.isSelect &&
                                                  f.childPagePermissionRights &&
                                                  f.childPagePermissionRights
                                                    .length ? (
                                                    f.childPagePermissionRights.map(
                                                      (g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onPermissionSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.pagePermissionTypeID
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onPermissionSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.pagePermissionTypeID
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {
                                                                    g.permissionTypeName
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    )
                                                  ) : (
                                                    <></>
                                                  )}

                                                  {f.isSelect &&
                                                    f.childRights &&
                                                    f.childRights.length > 0 &&
                                                    f.childRights
                                                      .filter(
                                                        df =>
                                                          df.rightName ==
                                                            READ ||
                                                          df.rightName == UPDATE
                                                      )
                                                      .map((g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onRightSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.rightId,
                                                                    g.rightName
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onRightSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.rightId,
                                                                  g.rightName
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {g.rightName}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      })}
                                                </>
                                              ) : (
                                                <>
                                                  {f.isSelect &&
                                                    f.childRights &&
                                                    f.childRights.length > 0 &&
                                                    f.childRights.map(
                                                      (g, key) => {
                                                        // Only Read right is available for Reporting Menus
                                                        if (
                                                          e.pageId ==
                                                          REPORTS_DASHBOARD
                                                        ) {
                                                          if (
                                                            g.rightName &&
                                                            g.rightName != READ
                                                          ) {
                                                            return
                                                          }
                                                        }
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onRightSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.rightId,
                                                                    g.rightName
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onRightSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.rightId,
                                                                  g.rightName
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {g.rightName}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    )}

                                                  {f.isSelect &&
                                                  f.childPagePermissionRights &&
                                                  f.childPagePermissionRights
                                                    .length ? (
                                                    f.childPagePermissionRights.map(
                                                      (g, key) => {
                                                        return (
                                                          <div
                                                            key={key}
                                                            className='gx-module-list-item'
                                                          >
                                                            <div className='gx-module-list-icon'>
                                                              <Checkbox
                                                                color='primary'
                                                                checked={
                                                                  g.isSelect
                                                                }
                                                                onClick={event => {
                                                                  onPermissionSelect(
                                                                    e.pageId,
                                                                    f.pageId,
                                                                    g.pagePermissionTypeID
                                                                  )
                                                                }}
                                                                // value="SelectTodo"
                                                                className='gx-icon-btn'
                                                              />
                                                            </div>
                                                            <div
                                                              className='gx-module-list-info'
                                                              onClick={event => {
                                                                onPermissionSelect(
                                                                  e.pageId,
                                                                  f.pageId,
                                                                  g.pagePermissionTypeID
                                                                )
                                                              }}
                                                            >
                                                              <div className='gx-module-todo-content'>
                                                                <div
                                                                  className={`gx-subject ${
                                                                    false &&
                                                                    'gx-text-muted gx-text-strikethrough'
                                                                  }`}
                                                                >
                                                                  {
                                                                    g.permissionTypeName
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    )
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        )
                                      })}
                                  </>
                                ) : (
                                  <>
                                    <div className='gx-module-box-content'>
                                      {e.isSelect &&
                                        e.pageRight &&
                                        e.pageRight.length &&
                                        e.pageRight.map((f, key) => {
                                          // Only Read right is available for Reporting Menus
                                          if (e.pageId == HOME) {
                                            if (
                                              f.rightName &&
                                              f.rightName != READ
                                            ) {
                                              return
                                            }
                                          }
                                          return (
                                            <div
                                              key={key}
                                              className='gx-module-list-item'
                                            >
                                              <div className='gx-module-list-icon'>
                                                <Checkbox
                                                  color='primary'
                                                  checked={f.isSelect}
                                                  onClick={event => {
                                                    onParentRightSelect(
                                                      e.pageId,
                                                      f.rightId
                                                    )
                                                  }}
                                                  // value="SelectTodo"
                                                  className='gx-icon-btn'
                                                />
                                              </div>
                                              <div
                                                className='gx-module-list-info'
                                                onClick={event => {
                                                  onParentRightSelect(
                                                    e.pageId,
                                                    f.rightId
                                                  )
                                                }}
                                              >
                                                <div className='gx-module-todo-content'>
                                                  <div
                                                    className={`gx-subject ${
                                                      false &&
                                                      'gx-text-muted gx-text-strikethrough'
                                                    }`}
                                                  >
                                                    {f.rightName}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        })}

                                      {e.isSelect &&
                                      e.pagePermission &&
                                      e.pagePermission.length ? (
                                        e.pagePermission.map((g, key) => {
                                          return (
                                            <div
                                              key={key}
                                              className='gx-module-list-item'
                                            >
                                              <div className='gx-module-list-icon'>
                                                <Checkbox
                                                  color='primary'
                                                  checked={g.isSelect}
                                                  onClick={event => {
                                                    onParentPermSelect(
                                                      e.pageId,
                                                      g.pagePermissionTypeID
                                                    )
                                                  }}
                                                  // value="SelectTodo"
                                                  className='gx-icon-btn'
                                                />
                                              </div>
                                              <div
                                                className='gx-module-list-info'
                                                onClick={event => {
                                                  onParentPermSelect(
                                                    e.pageId,
                                                    g.pagePermissionTypeID
                                                  )
                                                }}
                                              >
                                                <div className='gx-module-todo-content'>
                                                  <div
                                                    className={`gx-subject ${
                                                      false &&
                                                      'gx-text-muted gx-text-strikethrough'
                                                    }`}
                                                  >
                                                    {g.permissionTypeName}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        })
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            </Card>
                          </Panel>
                        </Collapse>
                      )
                    })}
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>
    </>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default AddEditRolesRights
